module.exports = __webpack_public_path__ + "static/media/tgle-ee.afb43a74.png";